import { createI18n } from 'vue-i18n'
import en from './en'
import fr from './fr'

export type MessageSchema = typeof fr

const i18n = createI18n<[MessageSchema], 'fr' | 'en'>({
  legacy: false, // Use Composition API mode
  locale: localStorage.getItem('user-locale') || 'fr', // French default
  fallbackLocale: 'en',
  messages: {
    fr,
    en,
  },
})

export default i18n
